import type { IconSvgObject } from './types';

const Mosque01Icon: IconSvgObject = [
  ["path", { d: "M18 12V10C18 9.44772 17.5523 9 17 9H7C6.44772 9 6 9.44772 6 10V12", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 13C20 12.4477 19.5523 12 19 12H5C4.44772 12 4 12.4477 4 13V22H20V13Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.50009 22V19C9.48279 16 12 15 12 15C12 15 14.5172 16 14.4999 19V22", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8.49231 9C7.88588 8.01654 7.49218 7.5 7.50012 6.5C7.49218 4 10.5 3.5 12 2C13.5 3.5 16.5081 4 16.5001 6.5C16.5081 7.5 16.1144 8.01654 15.5079 9", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Mosque01Icon;
